<template>
  <v-dialog :value="true" max-width="790" width="530" persistent>
    <v-card class="dialog-box">
      <v-card-title class="headline">
        {{ $t("NoWorkspaceAvailableOpen") }}
      </v-card-title>

      <div class="pl-6"></div>

      <v-card-actions>
        <v-btn
          @click="$emit('close')"
          :ripple="false"
          class="secondary-button ma-0"
        >
          <span style="color: black">{{ $t("Exit") }}</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "WorkspacesNotFoundDialogBox"
};
</script>

<style scoped>
.dialog-box .v-card__title {
  color: #b74f4f;
}

.secondary-button {
  border: 1px solid #707070;
  width: 100px;
  height: 32px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Network/Content/WorkspacesNotFoundDialogBox.vue